<ng-template #selectedDate let-type="type" let-text="text" let-date="date">
  <div class="flex tr-xsmall pr-medium-l" [attr.data-test-matrix-date]="type">
    <fcom-icon class="ir-xsmall flex--nogrow ms-xxsmall-r" [name]="type"></fcom-icon>
    <div class="flex flex--column flex--align-start">
      <span class="dn-mobile">{{ text | finLocalization }}</span>
      <div class="medium-type">{{ date | finDateFormat: 'FULL_NO_YEAR' }}</div>
    </div>
  </div>
</ng-template>

<fcom-modal
  [(open)]="airCalendarOpen"
  [title]="'airCalendar.flexibleTravelDates' | finLocalization"
  [fitToContent]="true"
  [buttons]="ModalButtons.CUSTOM"
  (close)="closeAirCalendar()"
>
  <div class="flex flex--center" *ngIf="airCalendarOpen && isAward">
    <fcom-notification [theme]="NotificationTheme.TRANSPARENT" class="block" [attr.data-test-notification]="'points'">
      {{ 'award.notifications.totalPoints' | finLocalization: { points: totalPoints | finPoints | finEmpty: '-' } }}
    </fcom-notification>
  </div>

  <fin-price-matrix
    [calendarList]="prices$ | async"
    [isAward]="isAward"
    (selectedDates)="selectCalendarDates($event)"
  ></fin-price-matrix>

  <div
    buttons
    class="airCalendarFooter flex flex--middle tr-xsmall align-left font-body-1"
    data-test-price-matrix-footer
  >
    <div class="flex flex--column flex--align-start starting-price-container">
      <div data-test-matrix-starting-price>
        {{ 'priceCalendar.pricesFrom' | finLocalization }}
        <span *ngIf="!isAward" class="medium-type"
          >&nbsp;{{ startingPrice$ | async | finPrice: true | finEmpty: '&ndash;' }}</span
        >
        <span *ngIf="isAward" class="medium-type"
          >&nbsp;{{
            'award.points' | finLocalization: { pointsAmount: startingPrice$ | async | finMap: 'amount' | finPoints }
          }}</span
        >
      </div>
      <div data-test-pax-amount-breakdown>{{ paxAmountBreakdown$ | async }}</div>
    </div>
    <div class="df-tablet-up flex-1">
      <ng-container
        [ngTemplateOutlet]="selectedDate"
        [ngTemplateOutletContext]="{
          type: 'departure',
          text: 'departure',
          date: (travelDates$ | async)?.departureDate
        }"
      ></ng-container>
      <ng-container
        *ngIf="(tripType$ | async) !== TripType.ONEWAY"
        [ngTemplateOutlet]="selectedDate"
        [ngTemplateOutletContext]="{ type: 'arrival', text: 'returnDate', date: (travelDates$ | async)?.returnDate }"
      ></ng-container>
    </div>
    <fcom-button
      class="continue-btn"
      [theme]="ButtonTheme.PRIMARY_HEATHER"
      [size]="ButtonSize.R_LARGE"
      [mode]="ButtonMode.FILL"
      [text]="'bookingSearch.search' | finLocalization"
      [disabled]="continueDisabled$ | async"
      (click)="navigateToBookingFlow()"
      data-test-aircalendar-continue-button
    >
    </fcom-button>
  </div>
</fcom-modal>
